import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/reports/')({
  component: ReportsIndex,
});

function ReportsIndex() {
  return <Navigate to="/reports/dashboards" replace />;
}
